<template>
  <!--  <SuccessModal-->
  <!--    :is-open="openSuccess"-->
  <!--    :close-modal="closeModal"-->
  <!--    :description="'Your payment was successful'"-->
  <!--    :header="'Success'"-->
  <!--  >-->
  <!--  </SuccessModal>-->
  <SuccessMessageModal
    :message="'Your wallet has been funded successfully'"
    :button-action="closeModal"
    :is-open="openSuccess"
    :cancel="closeModal"
  />
</template>

<script>
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
import { mapState } from "vuex";

export default {
  name: "SuccessPage",
  components: { SuccessMessageModal },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    })
  },
  data() {
    return {
      openSuccess: true
    };
  },
  methods: {
    closeModal() {
      this.openSuccess = false;
      RouterUtils.changeRouteUrlTo("/wallet");
    }
  }
};
</script>

<style scoped></style>
